import React from 'react'

const StandingsRank = ({rank}) => (
  
  <td className="standings-rank">
    <div className="rank">#{rank}</div>
  </td>
)

export default StandingsRank